import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreTagsLinkPostAsyncSlice } from './post';

export const coreTagsLinkReducers = combineReducers({
	post: coreTagsLinkPostAsyncSlice.asyncReducers
});

export const coreTagsLinkWatchers = combineAllWatchers([ coreTagsLinkPostAsyncSlice.asyncWatchers ]);
